import { maruyaApi } from './maruya-api'

export type RpaCredentialsStatus = {
  configured: boolean
  updated_by: string | null
  updated_at: string | null
}

export async function getRpaCredentialsStatus(): Promise<RpaCredentialsStatus> {
  return maruyaApi<RpaCredentialsStatus>('/v1/rpa/credentials/status')
}

export async function putRpaCredentials(
  loginId: string,
  password: string,
  subdomain: string,
): Promise<RpaCredentialsStatus> {
  return maruyaApi<RpaCredentialsStatus>('/v1/rpa/credentials', {
    method: 'PUT',
    body: {
      login_id: loginId,
      password,
      subdomain,
    },
  })
}
